<template>
<!-- Remember to include jQuery :) -->

  <div class="hello" style="text-align:right;">
    <my-room-navigator />
    <select v-model="filter" style="margin-left:5px; border-radius:4px; padding:4px 5px; background:#fff; font-size:12px;">
      <option value="">ALL</option>
      <option value="hair" >헤어</option>
      <option value="clothes" >옷</option>
      <option value="weapon" >액세서리</option>
      <option value="shoes">신발</option>
      <option value="face" >표정</option>
      <option value="pet" >펫</option>
    </select>&nbsp;&nbsp;
                  <div class="tab-content">
                <!-- <router-view/> -->
                <div>

                    <div class="item_box" v-for="item in items">
                      <div class="item_box_title">{{ item.item.name }}</div>
                      <div class="item_box_item"><img :src="'https://avatar.useschool.co.kr/avatar/img/item/' + item.item.type + '/' + item.item.code + '.png'"></div>
                      <div class="item_box_price_fame">
                        <span v-if="item.transaction.expireDate > 86400">{{ Math.ceil((item.transaction.expireDate - new Date() / 1000) / 86400)}}일 남음</span>
                        <span v-if="item.transaction.expireDate < 86400">{{ Math.ceil((item.transaction.expireDate - new Date() / 1000) / 3600)}}시간 남음</span>
                        </div>
                      <div class="item_box_buy_fame" @click="equipItem(item.transaction.id)" v-if="item.item.type">착용</div>

                    <br>

                    <!-- <div style="text-align: center; color: #fff; font-size: 14px; margin-top: 20px;">◀ 1 / 2 ▶</div> -->

                </div>
                <br>
					<div style="clear:both">&nbsp;</div>
                <div style="text-align:center; position:relative; top:00px; ">
                <router-link :to="'/my_room/inventory/' + (+currentPage - 1)" v-if="currentPage > 1"><span style="font-size: 12px; padding:2px 4px;" class="btn btn-danger">◀&nbsp;PREV</span></router-link>&nbsp;
                <router-link :to="'/my_room/inventory/' + (+currentPage + 1)" v-if="items.length >= 8"><span style="font-size: 12px; padding:2px 4px;" class="btn btn-primary">▶&nbsp;NEXT </span></router-link>
				</div>
              </div>
  </div>




  </div>

</template>

<script>
import axios from 'axios';
import MyRoomNavigator from '../components/MyRoomNavigator.vue';
export default {
  name: 'home',
  components: {
    MyRoomNavigator
  },
  methods: {
    fetchData(page) {
      this.currentPage = page;
        axios.get(this.$parent.persistent.apiUrl + 'inventory.php?page=' + page + '&uid=' + this.$parent.loginID + (this.filter ? '&filtertype=' + this.filter : ''))
        .then(response => {
            // console.log(response.data)
            this.items = response.data.items
        }).catch((error) => console.log(error));
    },
    equipItem(transactionId){
        axios.get(this.$parent.persistent.apiUrl + 'equip.php?transaction=' + transactionId + '&uid=' + this.$parent.loginID)
        .then(response => {
            // console.log(response.data)
            // this.items = response.data.items
            if(response.data.status == "error"){
              this.$parent.alert(response.data.reason)
            } else {
              this.$parent.fetchMyInfo()
            }
        }).catch((error) => console.log(error));
    }
},
  mounted(){

  },
    watch: {
    '$route.params': {
        handler(newValue) {
            const { page } = newValue

            this.fetchData(page)
        },
        immediate: true,
    },
    'filter': {
      handler(){
        this.fetchData(1)
      }
    }
},

data(){
  return {
    items: [],
    modalDesc: {
      price: [],
      buyPrice: "",
      itemName: ""

    },
    alertModal: "",
    currentPage: 1,
    filter: "",
    tiers: []
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
